import styles from './card.module.scss';
import { JetCatalogItem } from '@/types/jetCatalog.types';
import Image from 'next/image';
import { motion } from 'framer-motion';

const Card = ({ jet }: { jet: JetCatalogItem }) => {
  // const handleMoreDetails = () => {
  //   window.open(jet.pdf, '_blank');
  // };

  return (
    <motion.div
      className={styles.jetCatalogCard}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.3 }}
      layout
    >
      <Image
        src={jet.image}
        alt={jet.name}
        width={364}
        height={138}
        className={styles.jetCatalogCardImage}
      />
      <motion.div
        className={styles.jetCatalogCardTail}
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2 }}
      >
        <Image
          src="/img/jet-catalog/icon.svg"
          alt="tail"
          width={16}
          height={16}
        />
        {jet.tail}
      </motion.div>
      {jet.mostPopular && (
        <motion.div
          className={styles.jetCatalogPopular}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          Most popular
        </motion.div>
      )}
      <motion.div
        className={styles.jetCatalogCardContent}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <div className={styles.jetCatalogCardContentHeader}>
          <h3 className={styles.jetCatalogCardContentHeaderTitle}>
            {jet.name}
          </h3>
          <p className={styles.jetCatalogCardContentHeaderPassengers}>
            {jet.passengers} <span> places in total</span>
          </p>
        </div>
        <div className={styles.jetCatalogCardContentBody}>
          <p className={styles.jetCatalogCardContentBodyCategory}>
            {jet.category}
          </p>
          <p className={styles.jetCatalogCardContentBodyPrice}>
            {' '}
            from{' '}
            <span className={styles.jetCatalogCardContentBodyPriceValue}>
              {jet.price}
            </span>{' '}
            per hour
          </p>
        </div>
      </motion.div>
      {/* <motion.button
        className={styles.jetCatalogCardButton}
        onClick={handleMoreDetails}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        More details
      </motion.button> */}
    </motion.div>
  );
};

export default Card;
